import { defineStore } from "pinia";

export const useCountryCityStore = defineStore('countryCity', {
  state: () => ({
    countryCity: {},
    countryCities: [],
  }),
  actions: {
    setCountryCity(countryCity) {
      this.countryCity = countryCity
    },
    setCountryCities(countryCities) {
      this.countryCities = countryCities
    },
    addCountryCity(countryCity) {
      this.countryCities.unshift(countryCity)
    },
    updateCountryCity(countryCity) {
      let index = this.countryCities.findIndex(cl => cl.id === countryCity.id)
      this.countryCities.splice(index, 1, countryCity)
    },
    deleteCountryCity(countryCity) {
      let index = this.countryCities.findIndex(cl => cl.id === countryCity.id)
      this.countryCities.splice(index, 1)
    },
  },
});